import type { QueryClient } from '@tanstack/react-query'

import { groupsInfiniteQueryOptions } from './queries'

export const groupWorkspaces = {
  payments: {
    title: 'Payment Center',
    description:
      'Pilih grup untuk melihat tagihan, status pembayaran, dan sinkronisasi pembayaran yang sudah tersedia.',
    action: 'Lihat tagihan',
    tab: 'billed',
    subTab: 'all',
  },
  shipping: {
    title: 'Shipping Center',
    description:
      'Pilih grup untuk memproses pesanan, mencetak label, dan memantau pengiriman melalui alur yang sudah tersedia.',
    action: 'Kelola pengiriman',
    tab: 'processing',
    subTab: 'all',
  },
  settings: {
    title: 'Store Settings',
    description:
      'Kelola informasi toko, alamat pengirim, kontak, logo, dan tautan media sosial untuk setiap grup.',
    action: 'Atur toko',
    tab: 'unpaid',
    subTab: 'all',
  },
} as const

export type GroupWorkspace = keyof typeof groupWorkspaces

export async function loadGroupWorkspace(queryClient: QueryClient) {
  // The page owns retry/error UI; existing query keys keep data shared across menus.
  await queryClient.infiniteQuery(groupsInfiniteQueryOptions()).catch(() => undefined)
}
